import React from 'react';
import Row from '../../../../core/layout/Row';
import TextInput from '../../../../core/form/TextInput';
import get from 'lodash/get';
import Column from '../../../../core/layout/Column';

function EssayItemForm(props) {
  return (
    <Row>
      <Column size={6}>
        <TextInput
          required
          label="Min Characters"
          type="number"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'charactersMinLimit', '')}
          onChange={(value) => props.onChange('charactersMinLimit', value)}
          errorText={get(props.errors, 'charactersMinLimit', '')}
        />
      </Column>
    </Row>
  );
}

export default EssayItemForm;
